import { Region } from '../../../../../../graphql/__generated__';
import type {
  CalendarGridColDef,
  CalendarGridContext,
  CalendarGridRowData,
  CalendarGridSetFilterParams,
  CalendarGridSetFilterValuesFunc,
  CalendarGridValueFormatterFunc,
} from '../../CalendarGrid.model';

export type Value = CalendarGridRowData['exchangeRegion'];

export const setFilterValuesFunc: CalendarGridSetFilterValuesFunc<Region> = params => {
  const context = params.context as CalendarGridContext;
  params.success(context.regions.map(region => region.value));
};

export const setFilterValueFormatter: CalendarGridValueFormatterFunc<Region> = ({
  value,
  context,
}) => {
  const { regions = [] } = context as CalendarGridContext;

  if (!value) {
    return '(Blank)';
  }

  const region = regions.find(region => region.value === value);
  return region?.label ?? value;
};

const exchangeRegionColDef: CalendarGridColDef<Value> = {
  field: 'exchangeRegion',
  headerName: 'Region ⓘ',
  headerTooltip: 'Exchange Region',
  width: 112,
  type: 'text',
  filter: 'agSetColumnFilter',
  filterParams: {
    values: setFilterValuesFunc,
    valueFormatter: setFilterValueFormatter,
  } satisfies CalendarGridSetFilterParams<Region>,
};

export default exchangeRegionColDef;
